import app from './app';
import { saveAs } from 'file-saver';
import { ORDER_SERVICE_URL, REDIRECT_HP2B } from '../../libs/constants';

const getDirectCustomerPayments = (searchConfig, userId) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));
    let url = ORDER_SERVICE_URL + "/financialData/" + userId;
    const headerConfig = {
        headers: {
            "DRS-Fetch-Type": "getDirectCustomerPayments"
        }
    };

    await api.post(url, searchConfig, headerConfig)
        .then(response => {
            if (response.data) {
                dispatch({
                    type: "SET_MY_PAYMENTS_LIST",
                    payload: response.data
                });
            }
            dispatch(app.setLoading(false));
        })
        .catch(error => {
            console.log(error);
            dispatch(app.setLoading(false));
            dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
        });
};

const getIndirectCustomerPayments = (searchConfig, userId) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));
    let url = ORDER_SERVICE_URL + "/financialData/" + userId;
    const headerConfig = {
        headers: {
            "DRS-Fetch-Type": "getIndirectCustomerPayments"
        }
    };

    await api.post(url, searchConfig, headerConfig)
        .then(response => {
            if (response.data) {
                dispatch({
                    type: "SET_MY_PAYMENTS_LIST",
                    payload: response.data
                });
            }
            dispatch(app.setLoading(false));
        })
        .catch(error => {
            console.log(error);
            dispatch(app.setLoading(false));
            dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
        });
};

const getDirectCustomerFinancials = (searchConfig, userId) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));
    let url = ORDER_SERVICE_URL + "/financialData/" + userId;
    const headerConfig = {
        headers: {
            "DRS-Fetch-Type": "getDirectCustomerFinancials"
        }
    };

    await api.post(url, searchConfig, headerConfig)
        .then(response => {
            if (response.data) {
                dispatch({
                    type: "SET_MY_DIRECT_FINANCIALS_LIST",
                    payload: response.data
                });
            }
            dispatch(app.setLoading(false));
        })
        .catch(error => {
            console.log(error);
            dispatch(app.setLoading(false));
            dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
        });
};

const getPartnerFinancials = (searchConfig, userId) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));
    let url = ORDER_SERVICE_URL + "/partnerFinancialData/" + userId;
    const headerConfig = {
        headers: {
            "DRS-Fetch-Type": "getPartnerFinancial"
        }
    };

    await api.post(url, searchConfig, headerConfig)
        .then(response => {
            console.log("Response", response.data)
            if (response.data) {
                dispatch({
                    type: "SET_MY_PARTNER_FINANCIALS_LIST",
                    payload: response.data
                });
            }
            dispatch(app.setLoading(false));
        })
        .catch(error => {
            console.log(error);
            dispatch(app.setLoading(false));
            dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
        });
};

const getInDirectCustomerFinancials = (searchConfig, userId) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));
    let url = ORDER_SERVICE_URL + "/financialData/" + userId;
    const headerConfig = {
        headers: {
            "DRS-Fetch-Type": "getInDirectCustomerFinancials"
        }
    };

    await api.post(url, searchConfig, headerConfig)
        .then(response => {
            if (response.data) {
                dispatch({
                    type: "SET_MY_INDIRECT_FINANCIALS_LIST",
                    payload: response.data
                });
            }
            dispatch(app.setLoading(false));
        })
        .catch(error => {
            console.log(error);
            dispatch(app.setLoading(false));
            dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
        });
};

const downloadPymtInvPdf = (orderId, id, lineType = '', amountType = '') => async (dispatch, getState, api) => {
    const downloadConfig = {
        headers: {
            accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel",
            "DRS-Fetch-Type": "downloadPymtInvPdf"
        },
        responseType: "blob"
    };
    await api.post(ORDER_SERVICE_URL + '/downloadPymtInvPdf/' + id, {}, downloadConfig)
        .then(response => {
            saveAs(new Blob([response.data]), `${orderId}${lineType}.pdf`);
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
        });
};

const updateFinancialData = (value, columnName, rowIndex) => {
    return {
        type: 'UPDATE_FINANCIAL_DATA',
        value,
        columnName,
        rowIndex
    }
};
const updatePartnerInformation = (updatedFinalcialData) => async (dispatch, getState, api) => {
    try {
        dispatch(app.setLoading(true));

        const headerConfig = { headers: { "DRS-Fetch-Type": "getUpdatedPartnerFinancialData" } };
        await api.post(ORDER_SERVICE_URL + '/updatePartnerFinancialsData', updatedFinalcialData, headerConfig);

        dispatch(app.setLoading(false));
    } catch (error) {
        dispatch(app.setLoading(false));
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
    }
};

const updateFinancialInformation = (updatedFinalcialData) => async (dispatch, getState, api) => {
    try {
        dispatch(app.setLoading(true));

        const headerConfig = { headers: { "DRS-Fetch-Type": "getUpdatedFinancialData" } };
        await api.post(ORDER_SERVICE_URL + '/updateFinancialsAndOrderData', updatedFinalcialData, headerConfig);

        dispatch(app.setLoading(false));
    } catch (error) {
        dispatch(app.setLoading(false));
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
    }
};

const redirectToHP2B = () => async (dispatch, getState, api) => {
    try {
        dispatch(app.setLoading(true));

        const headerConfig = { headers: { "DRS-Fetch-Type": "redirectToHP2B" } };
        await api.get(REDIRECT_HP2B, {}, headerConfig);

        dispatch(app.setLoading(false));
    } catch (error) {
        dispatch(app.setLoading(false));
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
    }
};

const quoteActions = {
    getDirectCustomerPayments,
    getIndirectCustomerPayments,
    getDirectCustomerFinancials,
    getPartnerFinancials,
    getInDirectCustomerFinancials,
    downloadPymtInvPdf,
    updateFinancialData,
    updateFinancialInformation,
    updatePartnerInformation,
    redirectToHP2B
}

export default quoteActions;
